module.exports = __webpack_public_path__ + "img/plan3_book05.90f44267.png";